import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  PageTitle: {
    id: 'PageTitle',
    defaultMessage: 'My Learner Records | {siteName}',
    description: 'Title tag',
  },
});

export default messages;
